export class ApiError extends Error {
  constructor(
    public code: string,
    message: string,
    public status: number = 0,
    public data: unknown = undefined,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const res = await fetch(path, {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...init.headers,
    },
  });
  let body: { success?: boolean; data?: unknown; error?: { code?: string; message?: string } };
  try {
    body = await res.json();
  } catch {
    throw new ApiError('PARSE_ERROR', 'Failed to parse response', res.status);
  }
  if (!res.ok || body.success === false) {
    throw new ApiError(
      body.error?.code ?? 'UNKNOWN',
      body.error?.message ?? 'Request failed',
      res.status,
      body.data,
    );
  }
  return body.data as T;
}
